import React, { Component } from 'react'
import "../Styles/Title.css"

interface Props { }
interface State {
    letters: Array<string>;
}

export default class Title extends Component<Props, State> {
    state = {
        letters: ["C", "O", "L", "O", "R", "F", "U", "L", " ", "C", "A", "L", "C", "U", "L", "A", "T", "O", "R"]
    };

    generateRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    render() {
        var rainbowLetters = this.state.letters.map(letter => (
            <span
                style={
                    {
                        color: this.generateRandomColor()
                    }
                }
            >
                {letter}
            </span>
        ));
        return (
            <div className="Title">
                <div className="RainbowWordsAndEmoji">
                    <span role="img" aria-label="calculator">🖩</span>
                    <span className="RainbowWords">{rainbowLetters}</span>
                    <span role="img" aria-label="calculator">🖩</span>
                </div>
                <br />
                <h4>By Richard Liang</h4>
                <h6>
                    View source code
                    <span> </span>
                    <a href="https://github.com/RYLiang18/ColorfulCalculator-React">
                        here <span role="img" aria-label="react-logo">⚛️</span>
                    </a>
                </h6>
            </div>
        )
    }
}
